import { createContext, useContext, useState, useEffect } from "react";
import { jsx as _jsx } from "react/jsx-runtime";

const CourierLanguageContext = /*#__PURE__*/createContext(undefined);

const emptyData = {
  courierName: "",
  courierPhone: "",
  courierLocation: "",
  courierJoinDate: "",
  addresses: {
    nizami123: "",
    may28: "",
    nobel78: "",
    fevvareler12: "",
    park56: ""
  },
  customerNames: {
    aydin: "",
    leyla: "",
    rashad: "",
    elvin: "",
    nigar: ""
  },
  streetSuffix: "",
  city: ""
};

export function CourierLanguageProvider({
                                          children,
                                          courierName,
                                          courierPhone
                                        }) {
  const [language, setLanguage] = useState("aze");
  const [t, setT] = useState({});
  const [baseData, setBaseData] = useState(emptyData);

  useEffect(() => {
    fetch(`/locales/${language}.json`)
        .then(r => r.json())
        .then(json => {
          setT(json.translations);
          setBaseData(json.data);
        })
        .catch(err => console.error("Failed to load translations:", err));
  }, [language]);

  const value = {
    language,
    setLanguage,
    t,
    data: {
      ...baseData,
      courierName: courierName || baseData.courierName || "",
      courierPhone: courierPhone || baseData.courierPhone || ""
    }
  };

  return /*#__PURE__*/_jsx(CourierLanguageContext.Provider, {
    value: value,
    children: children
  });
}

export function useCourierLanguage() {
  const context = useContext(CourierLanguageContext);
  if (context === undefined) {
    throw new Error("useCourierLanguage must be used within a CourierLanguageProvider");
  }
  return context;
}